import {BASE_URL,GET, ROAMING_PARTNERS_List} from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";

export const fetchRoamingPartnersList = async (requestId) => {
  const token = await getAccessToken();
  const url = `${BASE_URL}${ROAMING_PARTNERS_List}`;
  return fetch(url, {
      method: GET,
      headers: {
        "Content-Type": "application/json",
        "userauth" : `bearer ${token}`
      },
    })
    .then(statusParsing)
    .then(jsonParsing);
};